import { render, staticRenderFns } from "./SysSpeechRateAnalysis.vue?vue&type=template&id=f39cb62e&scoped=true"
import script from "./SysSpeechRateAnalysis.vue?vue&type=script&lang=js"
export * from "./SysSpeechRateAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SysSpeechRateAnalysis.vue?vue&type=style&index=0&id=f39cb62e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39cb62e",
  null
  
)

export default component.exports